import * as React from "react";
import { CSSTransition } from "react-transition-group";
import {
  Grid,
  Typography,
  IconButton,
  withStyles,
  CircularProgress,
} from "@material-ui/core";
import { Close, ArrowBack } from "@material-ui/icons";
import { observer } from "mobx-react";
import i18n from "i18n";
import * as _ from "lodash";
import { CostPlanStore } from "modules/costPlan/CostPlanStore";
import imgDownload from "modules/costPlan/assets/export-cost-plan.svg";

const styles = (theme) => ({
  modal: {
    left: 0,
    zIndex: 2,
    top: 0,
    height: "100%",
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    position: "absolute" as any,
  },
  container: {
    top: 33,
    left: 40,
    zIndex: 2,
    height: "calc(100vh - 33px)",
    width: "calc(100% - 290px)",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    backgroundColor: "#F2F2F2",
  },
  closeLayerIcon: {
    right: 20,
    top: 20,
  },
  backLayerIcon: {
    left: 20,
    top: 20,
  },
  layerTitleContainer: {
    marginTop: 140,
  },
  layerTitle: {
    fontSize: "12px",
    fontFamily: "Raleway",
    fontWeight: 400,
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "520px",
    margin: "0 auto",
    marginTop: "30px",
    marginBottom: "70px",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
  publicLocations: {
    fontSize: 12,
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  cardProcessing: {
    width: 230,
    height: 230,
    margin: "30px 15px",
    display: "inline-block",
  },
  cardDownload: {
    backgroundColor: "white",
    transition: "box-shadow 300ms ease-in",
    width: 230,
    height: 230,
    margin: "30px 15px",
    "&:hover": {
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    },
    display: "inline-block",
  },
  layerSecondTitleMessage: {
    fontSize: "26px",
    fontFamily: "Raleway",
    fontWeight: 400,
    marginTop: 30,
  },
  download: {
    width: "100%",
    paddingTop: 25,
    height: 70,
    textAlign: "center" as any,
    fontSize: "16px",
    fontFamily: "Roboto",
    fontWeight: 500,
  },
});

type IProps = {
  classes: any;
};

@observer
class LayerExport extends React.Component<IProps> {
  state = {
    file: "",
  };

  handleCloseLayerAdd = () => {
    CostPlanStore.layerAdd = false;
  };

  downloadFile = () => {
    var element = document.createElement("a");
    element.setAttribute("download", CostPlanStore.fileName);
    element.setAttribute("href", CostPlanStore.urlDownload);

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  };

  render() {
    const { classes } = this.props;

    let processed = false;

    if (CostPlanStore.wbsFileExport) {
      processed =
        CostPlanStore.wbsFileExport.data.status === "processed" &&
        CostPlanStore.urlDownload != "";
    }

    const textTitle = !processed
      ? i18n.costplan.export.titleprocessing
      : i18n.costplan.export.titleprocessed;

    const cardProcessing = (
      <div className={classes.cardProcessing}>
        <div style={{ width: "100%", marginTop: 50, textAlign: "center" }}>
          <CircularProgress size={90} style={{ color: "#ABC200" }} />
          <div style={{ textAlign: "center", width: "100%" }}></div>
          <Typography component="span" className={classes.publicLocations}>
            {i18n.costplan.export.processing}
          </Typography>
        </div>
      </div>
    );

    const cardDownload = (
      <a
        style={{ color: "#ABC200", textDecoration: "underline" }}
        onClick={() => {
          this.downloadFile();
        }}
      >
        <div className={classes.cardDownload}>
          <label htmlFor="contained-button-file" style={{ cursor: "pointer" }}>
            <div
              style={{
                width: "100%",
                height: 162,
                backgroundColor: "rgba(171, 194, 0, 1)",
              }}
            >
              <img
                style={{ width: 80, position: "relative", top: 35 }}
                src={imgDownload}
              />
            </div>
            <div className={classes.download}>
              {i18n.costplan.export.download}
            </div>
          </label>
        </div>
      </a>
    );

    return (
      <CSSTransition
        in={CostPlanStore.layerAdd}
        enter={true}
        exit={true}
        timeout={300}
        classNames={{
          enter: classes.transitionEnter,
          enterActive: classes.transitionEnterActive,
          exit: classes.transitionLeave,
          exitActive: classes.transitionLeaveActive,
        }}
        unmountOnExit
      >
        <div className={classes.modal}>
          <Grid
            container
            className={classes.container}
            style={{ position: "absolute" }}
          >
            <IconButton
              onClick={this.handleCloseLayerAdd}
              className={classes.closeLayerIcon}
              style={{ position: "absolute", zIndex: 2 }}
            >
              <Close fontSize="small" />
            </IconButton>
            <IconButton
              onClick={this.handleCloseLayerAdd}
              className={classes.backLayerIcon}
              style={{ position: "absolute", zIndex: 2 }}
            >
              <ArrowBack fontSize="small" />
            </IconButton>
            <div
              style={{
                height: "80vh",
                overflow: "hidden",
                textAlign: "center",
              }}
            >
              <div className={classes.layerTitleContainer}></div>
              <div style={{ textAlign: "center", width: "100%" }}>
                <Typography className={classes.layerSecondTitleMessage}>
                  {textTitle}
                </Typography>
                <div
                  style={{ width: 520, margin: "0 auto", textAlign: "center" }}
                >
                  {processed ? cardDownload : cardProcessing}
                </div>
              </div>
            </div>
          </Grid>
        </div>
      </CSSTransition>
    );
  }
}

export default withStyles(styles)(LayerExport);



// WEBPACK FOOTER //
// ./src/modules/costPlan/components/layouts/LayerExport.tsx